import { marketplaceCampaignSchema } from "@redotech/redo-marketplace-common/campaigns";
import * as z from "zod";

export const getCampaignBySlug = {
  name: "getCampaignBySlug" as const,
  input: z.object({ slug: z.string().min(1, "Campaign slug is required") }),
  output: z.object({ campaign: marketplaceCampaignSchema.nullable() }),
};
